import { makeAutoObservable, observable } from 'mobx';

import { getDeviceSetting, setDeviceSetting } from '@/utils/localStorage';

export interface CoachMarkSpec {
  id: string;
  version: string;
  title: string;
  description: string;
  width: 'sm' | 'md' | 'lg';
}

const GLOBAL_TARGET = '';

function seenVersionKey(mark: CoachMarkSpec): string {
  return `coachMark:${mark.id}:seen-version`;
}

export function hasSeenCoachMark(mark: CoachMarkSpec): boolean {
  return getDeviceSetting(seenVersionKey(mark)) === mark.version;
}

export function markCoachMarkSeen(mark: CoachMarkSpec): void {
  setDeviceSetting(seenVersionKey(mark), mark.version);
}

export class CoachMarkState {
  private openTargets = observable.map<string, string>();

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  show(mark: CoachMarkSpec, target: string = GLOBAL_TARGET) {
    if (hasSeenCoachMark(mark)) return;
    this.openTargets.set(mark.id, target);
  }

  isOpen(mark: CoachMarkSpec, target: string = GLOBAL_TARGET): boolean {
    return this.openTargets.get(mark.id) === target;
  }

  dismiss(mark: CoachMarkSpec, target: string = GLOBAL_TARGET) {
    if (!this.isOpen(mark, target)) return;
    this.openTargets.delete(mark.id);
    markCoachMarkSeen(mark);
  }

  /** Closes every open mark without recording any as seen */
  closeAll() {
    this.openTargets.clear();
  }
}

export const coachMarks = new CoachMarkState();
